// extracted by mini-css-extract-plugin
module.exports = {"inputText":"inputText_inputText__2YbBA","inputMessage":"inputText_inputMessage__3qXYP"};